import { QuestionCircleOutlined } from '@ant-design/icons';
import { ActionType, ProColumns, ProFormSelect } from '@ant-design/pro-components';
import { Form, Popconfirm, Tooltip, message } from 'antd';
import { ROUTES } from 'base/routes/routes';
import BoxContainer from 'base/ui/components/BoxContainer';
import CustomButton from 'base/ui/components/Button';
import CustomSelect from 'base/ui/components/CustomSelect';
import CustomProTable from 'base/ui/components/CustomTable';
import * as Icon from 'base/ui/components/Icons';
import { cloneDeep } from 'lodash';
import { observer } from 'mobx-react';
import { ButtonDelete } from 'pages/Components/FunctionButton';
import PageWrapper from 'pages/Components/PageWrapper';
import { SearchForm, SearchItem } from 'pages/Components/SearchBox';
import { SearchModel } from 'pages/model';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { CommonModel } from 'services/Main/common_services';
import { UnfollowRemind } from 'services/Masterdata/unfollowRemind_services';
import { commonPresenter, commonStore, unfollowRemindPresenter, unfollowRemindStore } from 'stores/root_store';
import { PAGE_SIZE_DEFAULT } from 'utils/constants';

// Bỏ theo dõi nhắc nhở bảo hành
export type TableListItem = {
  key: number;
  stt: number;
  profileCode: string;
};



const createUnfollowRemind = () => {
  return observer(() => {
    const [form] = Form.useForm();
    const tableRef = useRef<ActionType>();

    //=====================================CHUYỂN NGÔN NGỮ=====================================//
    const { t } = useTranslation();

    const defaultColumn: ProColumns<UnfollowRemind>[] = [
      {
        title: 'STT',
        dataIndex: 'stt',
        width: 50,
        align: 'center',
      },
      // Mã khách hàng
      {
        title: 'Mã khách hàng',
        dataIndex: 'profileCode',
        width: 150
      },
      // Khách hàng
      {
        title: 'Khách hàng',
        dataIndex: 'profileName',
      },
      // Mã công ty
      {
        title: 'Mã công ty',
        dataIndex: 'companyCode',
        width: 150,
      },
      // Tên công ty
      {
        title: 'Tên công ty',
        dataIndex: 'companyName',
      },
      {
        title: 'Chức năng',
        dataIndex: 'chucNang',
        key: 'chucNang',
        width: 100,
        render: (_, record) => (
          <Popconfirm
            title="Xóa"
            description="Bạn có chắc muốn xóa không?"
            onConfirm={async () => {
              await unfollowRemindPresenter.delete(unfollowRemindStore, record.id)
              if (unfollowRemindStore.createUpdateRes.isSuccess) {
                message.success(unfollowRemindStore.createUpdateRes.message)
                tableRef.current?.reload()
              }
            }}
            icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
          >
            <Tooltip title="Xóa">
              <ButtonDelete />
            </Tooltip>
          </Popconfirm>
        ),
      },
    ];

    //--- DATA TABLE ------------------------------------------------------------
    const [dataPaging, setDataPaging] = useState<SearchModel>({
    });

    // Công ty
    const [listCompany, setListCompany] = useState<CommonModel[]>([]);
    // data table
    const [dataTable, setDataTable] = useState<UnfollowRemind[]>([]);

    // =================================================================================================================
    // =================================================================================================================
    // =================================================================================================================

    // Công ty
    const getDataCompany = async () => {
      await commonPresenter.getCompanyByAccountHasId(commonStore);
      if (commonStore.commonRespone.isSuccess) {
        setListCompany(commonStore.commonRespone.data);
      }
    };

    const getDataTable = async (dataSearch: any) => {
      await unfollowRemindPresenter.searchData(unfollowRemindStore, dataSearch);
      if (unfollowRemindStore.listUnfollowRemindRespone.isSuccess) {
        const dataTemp = cloneDeep(unfollowRemindStore.listUnfollowRemindRespone.data);
        setDataTable(dataTemp);
        return dataTemp;
      }
      setDataTable([]);
      return [];
    };

    useEffect(() => {
      getDataCompany()
    }, [])

    return (
      <PageWrapper
        breadcrumb={[{
          text: 'Bỏ theo dõi nhắc nhở bảo hành'
        }]}
        extras={
          <>
            <Link to={ROUTES.MASTER_DATA.UNFOLLOW_REMIND.CREATE.LINK}>
              <CustomButton type="primary" icon={<Icon.Plus className="!fill-white" />}>
                {t('btn.create')}
              </CustomButton>
            </Link>
          </>
        }
      >
        <BoxContainer>
          <SearchForm initialValues={{ actived: true }} form={form} column="col-2"
            onFinish={async (value) => {
              setDataPaging({
                paging: {
                  pageSize: PAGE_SIZE_DEFAULT,
                  pageIndex: 1,
                },
                ...Object.fromEntries(Object.entries(value).filter(([_, e]) => {
                  if (typeof e === 'boolean') {
                    return true
                  } else if (Array.isArray(e) && e.length === 0) {
                    return false
                  }
                  else {
                    return !!e
                  }
                }))
              })
              tableRef.current?.reload()
            }
            }
          >
            {/* Khách hàng */}
            <SearchItem label={t('marketing.khach-hang')}>
              <ProFormSelect
                showSearch
                name={'profileId'}
                fieldProps={{
                  filterOption: false
                }}
                debounceTime={300}
                request={async ({ keyWords }, props) => {
                  return await commonPresenter.getListCustomerHasId(commonStore, keyWords).then((data) => {

                    return data.map((i: CommonModel) => ({
                      label: `${i.value}`,
                      value: i.key || '',
                    })) || []
                  })

                }}
              />
            </SearchItem>
            {/* Công ty */}
            <SearchItem
              name={"companyId"}
              label={t("search-form.company")}
            >
              <CustomSelect
                allowClear
                options={listCompany}
                fieldNames={{ label: "value", value: "key" }}
                showSearch
                filterOption={(input, option) =>
                  (option?.value ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              />
            </SearchItem>

            <div className='col-span-2 mt-5 flex justify-center items-center'>
              <CustomButton type='primary' onClick={() => {
                form.submit()
              }}>
                Tìm kiếm
              </CustomButton>
            </div>
          </SearchForm>

          <CustomProTable
            columns={defaultColumn}
            rowKey="stt"
            size="small"
            dataSource={dataTable}
            search={false}
            actionRef={tableRef}
            request={async (params = {}, sort, filter) => {
              const data = await getDataTable({
                ...dataPaging,
              });
              return {
                data: data,
                success: unfollowRemindStore.listUnfollowRemindRespone.isSuccess,
              };
            }}
          />
        </BoxContainer>
      </PageWrapper>
    );
  });
}

export default createUnfollowRemind